import { Box, IconButton, TextField } from '@mui/material';
import React, { useCallback, useState } from 'react';

import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import PropTypes from 'prop-types';
import { makeStyles } from 'tss-react/mui';
import styles from './ChatInput.styles';
import { translate } from '/b2b/common/helpers/i18n';
import withRetranslate from '/b2b/common/hoc/withRetranslate';

const useStyles = makeStyles()(styles);

const ChatInput = props => {
    const { onSend, isStreaming, disabled, sendMessagePlaceholder, compact } = props;
    const { classes, cx } = useStyles();
    const [content, setContent] = useState('');

    const isDisabled = disabled || isStreaming;

    const handleChange = useCallback(event => {
        setContent(event.target.value);
    }, []);

    const handleSend = useCallback(() => {
        const trimmed = content.trim();
        if (!trimmed) return;
        onSend(trimmed);
        setContent('');
    }, [content, onSend]);

    const handleKeyDown = useCallback(
        event => {
            if (event.key === 'Enter' && !event.shiftKey) {
                event.preventDefault();
                handleSend();
            }
        },
        [handleSend]
    );

    return (
        <Box className={classes.root}>
            <Box className={classes.card}>
                <TextField
                    className={classes.input}
                    placeholder={translate(
                        sendMessagePlaceholder || 'aiAssistant.inputs.message.placeholder'
                    )}
                    multiline
                    maxRows={4}
                    value={content}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    disabled={isDisabled}
                    InputProps={{
                        classes: {
                            root: classes.fieldRoot,
                            input: classes.fieldInput,
                            notchedOutline: classes.fieldOutline,
                        },
                    }}
                    inputProps={{ autoComplete: 'off', autoCorrect: 'off', spellCheck: 'false' }}
                    variant="outlined"
                    size="small"
                />
                <IconButton
                    className={cx(classes.sendButton, {
                        [classes.sendButtonCompact]: compact,
                    })}
                    onClick={handleSend}
                    disabled={!content.trim() || isDisabled}
                    size="small"
                    aria-label={translate('aiAssistant.buttons.send.ariaLabel')}
                >
                    <ArrowUpwardIcon fontSize="small" />
                </IconButton>
            </Box>
        </Box>
    );
};

ChatInput.propTypes = {
    onSend: PropTypes.func.isRequired,
    isStreaming: PropTypes.bool,
    disabled: PropTypes.bool,
    sendMessagePlaceholder: PropTypes.string,
    compact: PropTypes.bool,
    shouldRetranslate: PropTypes.string,
};

export default withRetranslate(ChatInput);
